export const SITE_NAME = 'EduCraft';
export const SITE_URL = 'https://qr.beil.cz/'; // Fallback or current known URL
export const AR_URL = 'https://ar.beil.cz/'; // Fallback or current known URL
